import { useTranslation } from 'react-i18next'
import { authPort, userPreferencesPort } from '@/infra/config/beans'
import AccountHeader from '@/src/components/account/account-header/AccountHeader'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import StorePreference from '@/src/components/account/store-preference/StorePreference'
import TeamPreference from '@/src/components/account/team-preference/TeamPreference'
import LangPreference from '@/src/components/account/lang-preference/LangPreference'
import ReportBug from '@/src/components/account/report-bug/ReportBug'
import ForceUpdate from '@/src/components/account/force-update/ForceUpdate'
import { usePageHeaders } from '@/src/hooks/use-page-headers/usePageHeaders'
import { useEffect, useState } from 'react'
import { UserProfile } from '@/domains/auth/AuthenticationPort'
import { LogoutButton } from '@/src/components/account/logout-button/LogoutButton'

const Index = () => {
  const { t } = useTranslation('common')
  usePageHeaders('pages.my-account.title')
  const [currentUser, setCurrentUser] = useState<UserProfile>()
  useEffect(() => {
    let isMounted = true // Sécurité pour éviter les fuites de mémoire

    void authPort.getUserProfile().then((user) => {
      if (isMounted) {
        setCurrentUser(user)
      }
    })

    return () => {
      isMounted = false // Nettoyage si le composant est démonté avant la fin de la promesse
    }
  }, [])
  const { store, team, language } = useUserPreferences(userPreferencesPort)

  return (
    <div className="h-full overflow-hidden flex flex-col">
      <div className="flex flex-col items-center pt-6 pb-4">
        <AccountHeader firstName={currentUser?.firstName} email={currentUser?.mail} />
      </div>
      <div className="bg-white rounded-t-2xl shadow-md p-6 flex-1 flex flex-col gap-4 text-gray-900 overflow-y-auto">
        <div>
          <h2 className="text-lg font-semibold text-neutral mb-3">
            {t('pages.my-account.profile-section')}
          </h2>
          <div className="divide-y divide-gray-200">
            <StorePreference store={store} />
            <TeamPreference team={team} />
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h2 className="text-lg font-semibold text-neutral">
            {t('pages.my-account.app-settings-section')}
          </h2>
          <div className="divide-y divide-gray-200">
            <LangPreference language={language} />
            <ReportBug />
            <ForceUpdate />
          </div>
          <div className="w-full flex justify-center">
            <LogoutButton />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index
